import {
  Autocomplete,
  Box,
  CircularProgress,
  MenuItem,
  Modal,
  Select,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import { RxCross1 } from "react-icons/rx";
import { BsTrash } from "react-icons/bs";
import { FaMinus, FaPlus } from "react-icons/fa";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import moment from "moment";
import { useMutation, useQuery } from "@tanstack/react-query";
import LoadingBackdrop from "../../../common/particles.jsx/LoadingBackdrop";
import { getDistributorListV2 } from "../../../../services/purchaseOrderApi";
import useDebounce from "../../../hooks/useDebounce";
import { createDefecta } from "../../../../services/defecta";
import ModalSaveDefecta from "./ModalSaveDefecta";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1000,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};

const ModalCreateDefecta = ({
  open,
  setOpen,
  productArr,
  setProductArr,
  isWarehouse,
  refetchList,
}) => {
  const [reqProduct, setReqProduct] = useState([]);
  const [search, setSearch] = useState("");
  const [openConfirm, setOpenConfirm] = useState(false);
  const [isSave, setIsSave] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const debounce = useDebounce(search, 500);

  const handleClose = () => {
    setReqProduct([]);
    setErrorMessage("");
    setIsSave(false);
    setOpenConfirm(false);
    setOpen(false);
  };

  const handleDeleteProduct = (product, batchIndex) => {
    setErrorMessage("");
    const foundIndex = productArr.findIndex(
      (item) => item.batch_id === product.batch_id
    );

    const foundDistIndex = reqProduct.findIndex(
      (dist) => dist.distributor_id === product.distributor_id
    );

    if (foundIndex >= 0) {
      setProductArr([
        ...productArr.slice(0, foundIndex),
        ...productArr.slice(foundIndex + 1),
      ]);
    }

    if (foundDistIndex >= 0)
      setReqProduct([
        ...reqProduct.slice(0, foundDistIndex),
        {
          ...reqProduct[foundDistIndex],
          product: [
            ...reqProduct[foundDistIndex].product.slice(0, batchIndex),
            ...reqProduct[foundDistIndex].product.slice(batchIndex + 1),
          ],
        },
        ...reqProduct.slice(foundDistIndex + 1),
      ]);
  };

  const handleChangeUom = (newVal, dist, batchIndex) => {
    setErrorMessage("");
    var foundIndex = reqProduct.findIndex(
      (product) => product.distributor_id === dist.distributor_id
    );

    if (foundIndex >= 0) {
      setReqProduct([
        ...reqProduct.slice(0, foundIndex),
        {
          ...reqProduct[foundIndex],
          product: [
            ...reqProduct[foundIndex].product.slice(0, batchIndex),
            {
              ...reqProduct[foundIndex].product[batchIndex],
              satuan: newVal,
            },
            ...reqProduct[foundIndex].product.slice(batchIndex + 1),
          ],
        },
        ...reqProduct.slice(foundIndex + 1),
      ]);
    }
  };

  const handleChangeQty = (newVal, dist, batchIndex) => {
    setErrorMessage("");
    var foundIndex = reqProduct.findIndex(
      (product) => product.distributor_id === dist.distributor_id
    );

    if (foundIndex >= 0) {
      setReqProduct([
        ...reqProduct.slice(0, foundIndex),
        {
          ...reqProduct[foundIndex],
          product: [
            ...reqProduct[foundIndex].product.slice(0, batchIndex),
            {
              ...reqProduct[foundIndex].product[batchIndex],
              quantity: newVal,
            },
            ...reqProduct[foundIndex].product.slice(batchIndex + 1),
          ],
        },
        ...reqProduct.slice(foundIndex + 1),
      ]);
    }
  };

  const handleChangeValueNewDistributor = (
    newVal,
    dist,
    distIndex,
    batch,
    type
  ) => {
    setErrorMessage("");

    // loop through all in the batch for the same new distributor id, change the new_payment_method & date
    var temp = [...dist.product];
    var newObject =
      type === "pay"
        ? {
            new_payment_method: newVal,
            new_due_date: newVal === 1 ? "" : moment().format("YYYY-MM-DD"),
          }
        : { new_due_date: newVal ? moment(newVal).format("YYYY-MM-DD") : "" };

    dist.product.map((item, i) => {
      if (
        item.new_distributor_id &&
        item.new_distributor_id === batch.new_distributor_id
      ) {
        temp[i] = {
          ...temp[i],
          ...newObject,
        };
      }
    });

    setReqProduct([
      ...reqProduct.slice(0, distIndex),
      { ...reqProduct[distIndex], product: temp },
      ...reqProduct.slice(distIndex + 1),
    ]);
  };

  const handleChangeDistributor = (inputValue, dist, batchIndex) => {
    setErrorMessage("");

    var foundIndex = reqProduct.findIndex(
      (product) => product.distributor_id === 0
    );

    const foundDistributor = inputValue
      ? dist.product.findIndex(
          (item) =>
            item.new_distributor_id && item.new_distributor_id === inputValue.id
        )
      : -1;

    const foundExistingDistributor = inputValue
      ? reqProduct.findIndex((item) => item.distributor_id === inputValue.id)
      : -1;

    // foundDistributor >=0 if there's another product in N/A that has already selected current distributor
    // foundExistingDistributor >=0 if distributor found outside of N/A

    if (foundIndex >= 0)
      setReqProduct([
        ...reqProduct.slice(0, foundIndex),
        {
          ...reqProduct[foundIndex],
          product: [
            ...reqProduct[foundIndex].product.slice(0, batchIndex),
            {
              ...reqProduct[foundIndex].product[batchIndex],
              new_distributor_id: inputValue ? inputValue.id : null,
              new_distributor_name: inputValue ? inputValue.name : null,
              new_payment_method:
                foundExistingDistributor < 0
                  ? foundDistributor < 0
                    ? null
                    : reqProduct[foundIndex].product[foundDistributor]
                        .new_payment_method
                  : reqProduct[foundExistingDistributor].payment_method,
              new_due_date:
                foundExistingDistributor < 0
                  ? foundDistributor < 0
                    ? null
                    : reqProduct[foundIndex].product[foundDistributor]
                        .new_due_date
                  : reqProduct[foundExistingDistributor].due_date,
            },
            ...reqProduct[foundIndex].product.slice(batchIndex + 1),
          ],
        },
        ...reqProduct.slice(foundIndex + 1),
      ]);
    setSearch("");
  };

  const handleChangePaymentDistributor = (e, dist, type) => {
    setErrorMessage("");

    var temp = [...reqProduct];

    // change distributor box
    var foundIndex = temp.findIndex(
      (product) => product.distributor_id === dist.distributor_id
    );
    if (foundIndex >= 0)
      temp[foundIndex] = {
        ...reqProduct[foundIndex],
        payment_method:
          type === "pay"
            ? e.target.value
            : reqProduct[foundIndex].payment_method,
        due_date:
          type === "pay"
            ? e.target.value === 1
              ? ""
              : moment().format("YYYY-MM-DD")
            : e
            ? moment(e).format("YYYY-MM-DD")
            : "",
      };

    // change uncategorized distributor box
    foundIndex = reqProduct.findIndex(
      (product) => product.distributor_id === 0
    );

    if (foundIndex >= 0)
      temp[foundIndex].product.map((batch, batchIndex) => {
        if (
          batch.new_distributor_id &&
          batch.new_distributor_id === dist.distributor_id
        ) {
          temp[foundIndex].product[batchIndex] = {
            ...temp[foundIndex].product[batchIndex],
            new_payment_method:
              type === "pay"
                ? e.target.value
                : temp[foundIndex].product[batchIndex].new_payment_method,
            new_due_date:
              type === "pay"
                ? e.target.value === 1
                  ? null
                  : moment().format("YYYY-MM-DD")
                : e
                ? moment(e).format("YYYY-MM-DD")
                : "",
          };
        }
      });

    setReqProduct(temp);
  };

  const isDisableEdit = (dist, batch, batchIndex) => {
    if (!batch) return true;
    else
      return (
        (batch.new_distributor_id &&
          productArr.some(
            (item) => item.distributor_id === batch.new_distributor_id
          )) ||
        // found the same new dist id on another index before this one
        (batch.new_distributor_id &&
          dist.product.some(
            (item) =>
              item.new_distributor_id &&
              item.new_distributor_id === batch.new_distributor_id
          ) &&
          dist.product.findIndex(
            (item) =>
              item.new_distributor_id &&
              item.new_distributor_id === batch.new_distributor_id
          ) < batchIndex)
      );
  };

  const handleSubmit = () => {
    var body = reqProduct
      .filter((item) => item.distributor_id !== 0 && item.product.length > 0)
      .map((dist, distIndex) => ({
        distributor_id: dist.distributor_id,
        distributor_name: dist.distributor_name,
        payment_method: dist.payment_method,
        due_date: dist.due_date,
        product: dist.product.map((batch, batchIndex) => ({
          batch_id: batch.batch_id,
          quantity: batch.quantity,
          product_name: batch.product_name,
          product_id: batch.product_id,
          satuan: batch.satuan,
          batch_number: batch.batch_number,
          expired_date: batch.due_date,
          hna: batch.hna,
          discount: batch.discount,
          ppn: batch.ppn,
          dpp: batch.dpp,
          net_price: batch.net_price,
          subtotal: batch.subtotal,
          type_uom:
            batch.satuan === batch.packaging.type_box
              ? 0
              : batch.satuan === batch.packaging.type_strip
              ? 1
              : batch.satuan === batch.packaging.type_unit
              ? 2
              : 0,
        })),
      }));

    // push uncategorized distributor to body
    if (reqProduct.filter((item) => item.distributor_id === 0).length > 0) {
      reqProduct
        .filter((item) => item.distributor_id === 0)[0]
        .product.map((batch, batchIndex) => {
          // check if existing in body
          //// TRUE - append
          //// FALSE - push to body as new distributor

          const foundDistributor = batch.new_distributor_id
            ? body.findIndex(
                (item) => item.distributor_id === batch.new_distributor_id
              )
            : -1;
          if (foundDistributor < 0 && batch.new_distributor_id)
            body = [
              ...body,
              {
                distributor_id: batch.new_distributor_id,
                distributor_name: batch.new_distributor_name,
                payment_method: batch.new_payment_method,
                due_date: batch.new_due_date,
                product: [
                  {
                    batch_id: batch.batch_id,
                    quantity: batch.quantity,
                    product_name: batch.product_name,
                    product_id: batch.product_id,
                    satuan: batch.satuan,
                    batch_number: batch.batch_number,
                    expired_date: batch.due_date,
                    hna: batch.hna,
                    discount: batch.discount,
                    ppn: batch.ppn,
                    dpp: batch.dpp,
                    net_price: batch.net_price,
                    subtotal: batch.subtotal,
                    type_uom:
                      batch.satuan === batch.packaging.type_box
                        ? 0
                        : batch.satuan === batch.packaging.type_strip
                        ? 1
                        : batch.satuan === batch.packaging.type_unit
                        ? 2
                        : 0,
                  },
                ],
              },
            ];
          if (foundDistributor >= 0)
            body[foundDistributor].product = [
              ...body[foundDistributor].product,
              {
                batch_id: batch.batch_id,
                quantity: batch.quantity,
                product_name: batch.product_name,
                product_id: batch.product_id,
                satuan: batch.satuan,
                batch_number: batch.batch_number,
                expired_date: batch.due_date,
                hna: batch.hna,
                discount: batch.discount,
                ppn: batch.ppn,
                dpp: batch.dpp,
                net_price: batch.net_price,
                subtotal: batch.subtotal,
                type_uom:
                  batch.satuan === batch.packaging.type_box
                    ? 0
                    : batch.satuan === batch.packaging.type_strip
                    ? 1
                    : batch.satuan === batch.packaging.type_unit
                    ? 2
                    : 0,
              },
            ];
        });
    }

    mutateDefecta({
      data: body,
      warehouse: isWarehouse ? isWarehouse : false,
    });
  };

  const { data: dataDistributor, isFetching } = useQuery({
    queryKey: ["distributor-list", debounce],
    queryFn: () =>
      getDistributorListV2(100, 1, debounce, isWarehouse ? isWarehouse : false),
  });

  const { mutate: mutateDefecta, isLoading } = useMutation({
    mutationFn: createDefecta,
    onSuccess: () => {
      refetchList();
      handleClose();
    },
    onError: (err) => {
      setErrorMessage(err.message.id ? err.message.id : err.message);
    },
  });

  useEffect(() => {
    if (isSave) {
      handleSubmit();
    }
  }, [isSave]);

  useEffect(() => {
    if (open && productArr) {
      setReqProduct(
        Object.keys(
          Object.groupBy(productArr, ({ distributor_id }) => distributor_id)
        ).map((item, i) => {
          var object = Object.groupBy(
            productArr,
            ({ distributor_id }) => distributor_id
          )[item];

          return {
            distributor_id: object[0].distributor_id,
            distributor_name: object[0].distributor_name,
            product: Object.groupBy(
              productArr,
              ({ distributor_id }) => distributor_id
            )[item].map((item) => ({
              ...item,
              quantity: 0,
              satuan: item.packaging.type_box,
            })),
          };
        })
      );
    }
  }, [open]);

  return (
    <>
      <LoadingBackdrop
        isLoading={isLoading || (reqProduct.length === 0 && open)}
      />
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            ...style,
            maxWidth: "75%",
            overflowY: "hidden",
            overflowX: "wrap",
            maxHeight: "80vh",
            padding: 0,
          }}
          className="text-left text-[12px] w-3/4 lg:w-2/3 h-full text-[#2C3E5D]"
        >
          <div className="flex justify-between items-center px-8 py-4">
            <p className="text-[18px] font-semibold">Buat PO</p>
            <RxCross1
              className="cursor-pointer hover:text-red-500"
              onClick={handleClose}
            />
          </div>
          <div className="px-8 pb-4 overflow-y-auto overflow-x-hidden max-h-[55vh] ">
            {open && reqProduct.length === 0 ? (
              <div className="py-8 flex items-center justify-center">
                <CircularProgress />
              </div>
            ) : (
              <>
                {reqProduct
                  .filter((item) => item.distributor_id !== 0)
                  .map((dist, distIndex) => {
                    if (dist.product.length > 0)
                      return (
                        <div
                          className="mb-4 p-2 border-2 rounded-lg"
                          key={distIndex}
                        >
                          <p className="text-[18px] mb-2 font-semibold">
                            {dist.distributor_name}
                          </p>
                          <div className="mb-2">
                            {dist.product.map((batch, batchIndex) => {
                              return (
                                <div
                                  className={`${
                                    batchIndex % 2 === 0 ? "bg-gray-100" : ""
                                  } p-3`}
                                >
                                  <div className="md:flex items-center justify-between">
                                    <p>{batch.product_name}</p>
                                    <div className="md:flex gap-2 items-center">
                                      <div className="mb-2 md:mb-0 flex gap-2 items-center">
                                        <BsTrash
                                          className={`text-red-500 text-[16px] ${
                                            isLoading
                                              ? "text-gray-300 cursor-default"
                                              : "hover:text-gray-300 cursor-pointer"
                                          }`}
                                          onClick={() => {
                                            if (!isLoading)
                                              handleDeleteProduct(
                                                batch,
                                                batchIndex
                                              );
                                          }}
                                        />

                                        <div className="flex items-center gap-2 rounded-md border-2 p-2 bg-white w-full md:w-fit">
                                          <button
                                            type="button"
                                            className={`text-[16px] hover:text-gray-300 text-gray-500 disabled:text-gray-300`}
                                            disabled={
                                              batch.quantity === 0 || isLoading
                                            }
                                            onClick={() =>
                                              handleChangeQty(
                                                batch.quantity - 1,
                                                dist,
                                                batchIndex
                                              )
                                            }
                                          >
                                            <FaMinus />
                                          </button>
                                          <input
                                            className="w-full md:w-[70px] text-center focus:outline-none"
                                            type="text"
                                            value={batch.quantity}
                                            onChange={(e) => {
                                              if (
                                                !isNaN(Number(e.target.value))
                                              )
                                                handleChangeQty(
                                                  Number(e.target.value),
                                                  dist,
                                                  batchIndex
                                                );
                                            }}
                                          />
                                          <button
                                            type="button"
                                            className={`text-[16px] hover:text-gray-300 text-gray-500 disabled:text-gray-300`}
                                            onClick={() => {
                                              handleChangeQty(
                                                batch.quantity + 1,
                                                dist,
                                                batchIndex
                                              );
                                            }}
                                          >
                                            <FaPlus />
                                          </button>
                                        </div>
                                      </div>

                                      <div className="w-full md:w-[150px]">
                                        <Select
                                          value={batch.satuan}
                                          onChange={(e) =>
                                            handleChangeUom(
                                              e.target.value,
                                              dist,
                                              batchIndex
                                            )
                                          }
                                          sx={{
                                            background: "#fff",
                                            width: "100%",
                                            marginBottom: 1,
                                          }}
                                        >
                                          <MenuItem value={0} disabled>
                                            Pilih Satuan
                                          </MenuItem>
                                          {[
                                            batch.packaging.type_box,
                                            batch.packaging.type_strip,
                                            batch.packaging.type_unit,
                                          ].map((item) => (
                                            <MenuItem value={item}>
                                              {item}
                                            </MenuItem>
                                          ))}
                                        </Select>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </div>

                          <div className="md:flex gap-2 items-center">
                            <Select
                              value={
                                dist.payment_method ? dist.payment_method : 0
                              }
                              onChange={(e) => {
                                handleChangePaymentDistributor(e, dist, "pay");
                              }}
                              sx={{ width: "100%", marginBottom: 1 }}
                            >
                              <MenuItem value={0} disabled>
                                Pilih Metode Pembayaran
                              </MenuItem>
                              <MenuItem value={1}>Tunai</MenuItem>
                              <MenuItem value={2}>Kredit</MenuItem>
                            </Select>
                            <DesktopDatePicker
                              views={["year", "month", "day"]}
                              label="Jatuh Tempo Pembayaran"
                              onChange={(newDate) => {
                                handleChangePaymentDistributor(
                                  newDate,
                                  dist,
                                  "date"
                                );
                              }}
                              value={
                                dist.due_date && dist.due_date !== ""
                                  ? dist.due_date
                                  : null
                              }
                              disabled={dist.payment_method !== 2 || isLoading}
                              sx={{ width: "100%", marginBottom: 1 }}
                              renderInput={(params) => {
                                return (
                                  <TextField
                                    fullWidth
                                    sx={{ marginBottom: 1 }}
                                    {...params}
                                  />
                                );
                              }}
                            />
                          </div>
                        </div>
                      );
                  })}
                {/* products with no distributor */}
                {reqProduct
                  .filter((item) => item.distributor_id === 0)
                  .map((dist, distIndex) => {
                    return (
                      <div
                        className="mb-4 p-2 border-2 rounded-lg"
                        key={distIndex}
                      >
                        <div className="mb-2">
                          {dist.product.map((batch, batchIndex) => {
                            return (
                              <div
                                className={`${
                                  batchIndex % 2 === 0 ? "bg-gray-100" : ""
                                } p-3`}
                              >
                                <div className="md:flex items-center justify-between">
                                  <p>{batch.product_name}</p>
                                  <div>
                                    <Autocomplete
                                      fullWidth
                                      loading={isFetching}
                                      disablePortal
                                      disabled={isLoading}
                                      options={
                                        dataDistributor &&
                                        dataDistributor.data !== null
                                          ? dataDistributor.data
                                          : []
                                      }
                                      value={
                                        batch.new_distributor_id &&
                                        dataDistributor
                                          ? dataDistributor.data.find(
                                              (item) =>
                                                item.id ===
                                                batch.new_distributor_id
                                            )
                                          : null
                                      }
                                      onChange={(_, inputValue) =>
                                        handleChangeDistributor(
                                          inputValue,
                                          dist,
                                          batchIndex
                                        )
                                      }
                                      onInputChange={(
                                        _,
                                        onInputValue,
                                        reason
                                      ) => {
                                        if (reason === "input") {
                                          setSearch(onInputValue);
                                        }
                                      }}
                                      getOptionLabel={(option) =>
                                        option.name || ""
                                      }
                                      renderInput={(params) => (
                                        <TextField
                                          sx={{
                                            background: "#fff",
                                            marginBottom: 1,
                                          }}
                                          placeholder="Pilih Distributor"
                                          {...params}
                                        />
                                      )}
                                      ListboxProps={{
                                        style: {
                                          maxHeight: "150px",
                                        },
                                      }}
                                    />
                                    <div className="md:flex gap-2 items-center">
                                      <div className="mb-2 md:mb-0 flex gap-2 items-center">
                                        <BsTrash
                                          className="text-red-500 hover:text-gray-300 cursor-pointer text-[16px]"
                                          onClick={() => {
                                            if (!isLoading)
                                              handleDeleteProduct(
                                                batch,
                                                batchIndex
                                              );
                                          }}
                                        />

                                        <div className="flex items-center gap-2 rounded-md border-2 p-2 bg-white w-full md:w-fit">
                                          <button
                                            type="button"
                                            className={`text-[16px] hover:text-gray-300 text-gray-500 disabled:text-gray-300`}
                                            disabled={
                                              batch.quantity === 0 || isLoading
                                            }
                                            onClick={() =>
                                              handleChangeQty(
                                                batch.quantity - 1,
                                                dist,
                                                batchIndex
                                              )
                                            }
                                          >
                                            <FaMinus />
                                          </button>
                                          <input
                                            className="w-full md:w-[70px] text-center focus:outline-none"
                                            type="text"
                                            value={batch.quantity}
                                            disabled={isLoading}
                                            onChange={(e) => {
                                              if (
                                                !isNaN(Number(e.target.value))
                                              )
                                                handleChangeQty(
                                                  Number(e.target.value),
                                                  dist,
                                                  batchIndex
                                                );
                                            }}
                                          />
                                          <button
                                            type="button"
                                            className={`text-[16px] hover:text-gray-300 text-gray-500 disabled:text-gray-300`}
                                            disabled={isLoading}
                                            onClick={() => {
                                              handleChangeQty(
                                                batch.quantity + 1,
                                                dist,
                                                batchIndex
                                              );
                                            }}
                                          >
                                            <FaPlus />
                                          </button>
                                        </div>
                                      </div>

                                      <div className="w-full md:w-[150px]">
                                        <Select
                                          disabled={isLoading}
                                          value={batch.satuan}
                                          onChange={(e) =>
                                            handleChangeUom(
                                              e.target.value,
                                              dist,
                                              batchIndex
                                            )
                                          }
                                          sx={{
                                            background: "#fff",
                                            width: "100%",
                                            marginBottom: 1,
                                          }}
                                        >
                                          <MenuItem value={0} disabled>
                                            Pilih Satuan
                                          </MenuItem>
                                          {[
                                            batch.packaging.type_box,
                                            batch.packaging.type_strip,
                                            batch.packaging.type_unit,
                                          ].map((item) => (
                                            <MenuItem value={item}>
                                              {item}
                                            </MenuItem>
                                          ))}
                                        </Select>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="md:flex gap-2 items-center">
                                  <Select
                                    value={
                                      batch.new_distributor_id &&
                                      batch.new_payment_method
                                        ? batch.new_payment_method
                                        : 0
                                    }
                                    onChange={(e) =>
                                      handleChangeValueNewDistributor(
                                        e.target.value,
                                        dist,
                                        distIndex,
                                        batch,
                                        "pay"
                                      )
                                    }
                                    sx={{
                                      width: "100%",
                                      marginBottom: 1,
                                      background: "#fff",
                                    }}
                                    disabled={
                                      !batch.new_distributor_id ||
                                      isLoading ||
                                      isDisableEdit(dist, batch, batchIndex)
                                    }
                                  >
                                    <MenuItem value={0} disabled>
                                      Pilih Metode Pembayaran
                                    </MenuItem>
                                    <MenuItem value={1}>Tunai</MenuItem>
                                    <MenuItem value={2}>Kredit</MenuItem>
                                  </Select>
                                  <DesktopDatePicker
                                    views={["year", "month", "day"]}
                                    label="Jatuh Tempo Pembayaran"
                                    onChange={(newDate) => {
                                      handleChangeValueNewDistributor(
                                        newDate
                                          ? moment(newDate).format("YYYY-MM-DD")
                                          : "",
                                        dist,
                                        distIndex,
                                        batch,
                                        "date"
                                      );
                                    }}
                                    value={
                                      batch.new_due_date &&
                                      batch.due_date !== ""
                                        ? batch.new_due_date
                                        : null
                                    }
                                    disabled={
                                      !batch.new_payment_method ||
                                      batch.new_payment_method !== 2 ||
                                      isLoading ||
                                      isDisableEdit(dist, batch, batchIndex)
                                    }
                                    sx={{ width: "100%", marginBottom: 1 }}
                                    renderInput={(params) => {
                                      return (
                                        <TextField
                                          fullWidth
                                          sx={{
                                            marginBottom: 1,
                                            background: "#fff",
                                          }}
                                          {...params}
                                        />
                                      );
                                    }}
                                  />
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    );
                  })}
              </>
            )}
          </div>

          <p className="text-red-500 mb-2 px-8">{errorMessage}</p>

          <div className="flex justify-end items-center px-8 py-4 gap-2">
            <button
              type="button"
              className="border-2 py-2 px-4 rounded-md bg-[#6F955B] border-[#6F955B] text-white hover:bg-gray-300 disabled:bg-gray-300"
              disabled={
                isLoading ||
                !reqProduct.every((dist) =>
                  dist.product.every(
                    (batch) =>
                      batch.quantity > 0 &&
                      ((dist.distributor_id === 0 &&
                        batch.new_distributor_id &&
                        batch.new_distributor_id !== 0 &&
                        batch.new_payment_method &&
                        batch.new_payment_method > 0) ||
                        (dist.distributor_id !== 0 && dist.payment_method > 0))
                  )
                )
              }
              onClick={() => setOpenConfirm(true)}
            >
              {isLoading ? <CircularProgress size={10} /> : "Buat PO"}
            </button>
          </div>
        </Box>
      </Modal>

      <ModalSaveDefecta
        open={openConfirm}
        setOpen={setOpenConfirm}
        setConfirm={setIsSave}
      />
    </>
  );
};

export default ModalCreateDefecta;
